import { render } from "./FeaturesSection.vue?vue&type=template&id=6c913432&scoped=true&ts=true"
import script from "./FeaturesSection.vue?vue&type=script&lang=ts"
export * from "./FeaturesSection.vue?vue&type=script&lang=ts"

import "./FeaturesSection.vue?vue&type=style&index=0&id=6c913432&scoped=true&lang=css"

import exportComponent from "/Users/pontustengroth/Desktop/git/shipd/apps/shipd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c913432"]])

export default __exports__